// extracted by mini-css-extract-plugin
module.exports = {"error":"error__sZsXJ","title":"title__1KSm7","text":"text__6jGC6"};